import Cookies from 'js-cookie'

import store from '../store.js'

const TokenKey = 'vue_admin_template_token'

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}


export function getToken() {
    return Cookies.get(TokenKey)
}

export function getTokenBykey(key) {
    return Cookies.get(key)
}

export function removeTokenBykey(key) {
    return Cookies.remove(key)
}

export function setTokenBykey(key,token) {
    return Cookies.set(key, token)
}
export function getHeadInsStaffCode(){
    let staffDTO = JSON.parse(getToken());
    return staffDTO.staffCode;
}
//获取自动收费规则
export function getChargeTime() {
    return JSON.parse(getToken()).chargeTime;
}
export function getStaffCode() {
    let staffDTO = JSON.parse(getToken());
    if(isChain(staffDTO)){
        return store.state.activeStaffCode;
    }
    return staffDTO.staffCode;
}
function isChain(staffDTO){
    if(staffDTO.institutionDTO != null){
        if(staffDTO.institutionDTO.isChain == 1 && staffDTO.institutionDTO.chainType != "son"){
            if(store.state.activeStaffCode != null){
                // console.log(store.state.activeInstitutionCode);
                return true
            }
        }
    }
}
export function getInstitutionCode() {
    let staffDTO = JSON.parse(getToken());
    if(isChain(staffDTO)){
        return store.state.activeInstitutionCode;
    }

    return staffDTO.institutionCode;
}

//查询按钮功能
export function getMenuButton(list,routePath) {
    let menu = null;
    for(let i = 0;i<list.length;i++){
        let url = list[i].url;
        if(url==routePath){
            menu=list[i].listMenuButtonSelected;
            break;
        }else{
            let listMenuDTO = list[i].listMenuDTO;
            if(listMenuDTO!=null&&listMenuDTO.length>0){
                //二级循环
                for(let j = 0;j<listMenuDTO.length;j++){
                    let url = listMenuDTO[j].url;
                    if(url==routePath){
                        menu=listMenuDTO[j].listMenuButtonSelected;
                        break;
                    }else{
                        //3级循环
                        let listMenuDTO3 = listMenuDTO[j].listMenuDTO;
                        if(listMenuDTO3!=null&&listMenuDTO3.length>0){
                            for(let k = 0;k<listMenuDTO3.length;k++){
                                let url = listMenuDTO3[k].url;
                                if(url==routePath){
                                    menu=listMenuDTO3[k].listMenuButtonSelected;
                                    break;
                                }     
                            }
                        }
                    }
                }
            }
        }
    } 

    return menu;
}

